import React from 'react'
import PropTypes from 'prop-types'
import { isString } from 'utils/types'
import { prop } from 'ramda'
import { Header, Paragraph, Icon } from 'components/patterns'
import { Link } from 'react-router-dom'
import { CardWrapper, CardContent, SelectedIndicator } from './Card.style'

const Card = ({
  selected,
  header,
  onClick,
  onClickDisabled,
  content,
  linkIcon,
  linkUri,
  index,
  cardSize,
  linkTarget,
}) => (
  <CardWrapper
    selected={selected}
    clickable={!onClickDisabled}
    onClick={onClickWrapper(onClick, onClickDisabled, index)}
    cardSize={cardSize}
  >
    <SelectedIndicator selected={selected} height={prop('height', cardSize)} />
    <CardContent>
      {isString(header) ? <Header type="h3">{header}</Header> : <>{header}</>}
      {isString(content) ? (
        <Paragraph size="small">{content}</Paragraph>
      ) : (
        <>{content}</>
      )}
    </CardContent>
    {linkIcon && linkUri && (
      <Link to={linkUri} target={linkTarget}>
        {isString(linkIcon) ? <Icon icon={linkIcon} /> : <>{linkIcon}</>}
      </Link>
    )}
  </CardWrapper>
)

const onClickWrapper = (onClick, onClickDisabled, index) => (e) => {
  // ToDo: 12/11/19 - verify and/or remove this onClickDisabled
  if (!onClickDisabled) {
    onClick(index)
  }
}

Card.defaultProps = {
  onClickDisabled: false,
  onClick: () => {},
  index: 0,
  selected: false,
  cardSize: {},
  linkTarget: '_self',
}

Card.propTypes = {
  selected: PropTypes.bool,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  onClickDisabled: PropTypes.bool,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  linkIcon: PropTypes.oneOf([PropTypes.string, PropTypes.node]),
  linkUri: PropTypes.string,
  index: PropTypes.number,
  cardSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  linkTarget: PropTypes.string,
}

export default Card
